import { Navigate } from "react-router-dom";
import PermissionOnboarding from "./PermissionOnboarding";

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    return (
        <>
            {children}
            <PermissionOnboarding />
        </>
    );
};

export default PrivateRoute;
